/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { ApiError } from './ApiError'
import { ApiErrorFromJSON, ApiErrorFromJSONTyped, ApiErrorToJSON } from './ApiError'
import type { PaginatedFAQAdmin } from './PaginatedFAQAdmin'
import {
  PaginatedFAQAdminFromJSON,
  PaginatedFAQAdminFromJSONTyped,
  PaginatedFAQAdminToJSON,
} from './PaginatedFAQAdmin'

/**
 *
 * @export
 * @interface EnvelopedFAQListFAQAdmin
 */
export interface EnvelopedFAQListFAQAdmin {
  /**
   *
   * @type {PaginatedFAQAdmin}
   * @memberof EnvelopedFAQListFAQAdmin
   */
  body: PaginatedFAQAdmin
  /**
   *
   * @type {Array<ApiError>}
   * @memberof EnvelopedFAQListFAQAdmin
   */
  errors: Array<ApiError>
}

/**
 * Check if a given object implements the EnvelopedFAQListFAQAdmin interface.
 */
export function instanceOfEnvelopedFAQListFAQAdmin(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'body' in value
  isInstance = isInstance && 'errors' in value

  return isInstance
}

export function EnvelopedFAQListFAQAdminFromJSON(json: any): EnvelopedFAQListFAQAdmin {
  return EnvelopedFAQListFAQAdminFromJSONTyped(json, false)
}

export function EnvelopedFAQListFAQAdminFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EnvelopedFAQListFAQAdmin {
  if (json === undefined || json === null) {
    return json
  }
  return {
    body: PaginatedFAQAdminFromJSON(json['body']),
    errors: (json['errors'] as Array<any>).map(ApiErrorFromJSON),
  }
}

export function EnvelopedFAQListFAQAdminToJSON(value?: EnvelopedFAQListFAQAdmin | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    body: PaginatedFAQAdminToJSON(value.body),
    errors: (value.errors as Array<any>).map(ApiErrorToJSON),
  }
}
